// src/components/modal/modal_all_promotion.js
import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import Promo from '../../../class/Promo/Promo';
import AuthService from '../../../class/services/AuthService';
import { useTranslation } from 'react-i18next';
import ModalPromotions from './modalPromotions.js';

const ModalAllPromotions = ({ show, onClose, lang }) => {
  const { t } = useTranslation();
  const [promos, setPromos] = useState([]);
  const [loading, setLoading] = useState(false);
  const modalBodyRef = useRef(null);

  // для внутрішньої (детальної) модалки
  const [detailOpen, setDetailOpen] = useState(false);
  const [detailId, setDetailId] = useState(null);

  // завантажуємо всі промо
  useEffect(() => {
    if (!show) return;
    (async () => {
      setLoading(true);
      try {
        const currency = AuthService.getCustom('currency');
        const response = await Promo.getPromoHome(currency);
        setPromos(
          response.data.map(p => ({
            content_id: p.content_id,
            title: JSON.parse(p.title)[lang] || JSON.parse(p.title).en,
            img: JSON.parse(p.img).logo,
          }))
        );
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    })();
  }, [show, lang]);

  // закриття по кліку поза межами
  useEffect(() => {
    const handler = e => {
      // якщо внутрішнє модальне відкрите — не закривай велике
      if (detailOpen) return;
  
      if (show && modalBodyRef.current && !modalBodyRef.current.contains(e.target)) {
        onClose();
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [show, onClose, detailOpen]);
  

  // відкриваємо детальну модалку
  const openDetail = id => {
    setDetailId(id);
    setDetailOpen(true);
  };
  const closeDetail = () => {
    setDetailOpen(false);
    setDetailId(null);
  };

  if (!show) return null;

  return (
    <>
      
      {detailOpen &&
         ReactDOM.createPortal(
           <ModalPromotions
             isOpen={detailOpen}    
             onClose={closeDetail}   
             content_id={detailId}
             lang={lang}
           />,
           document.body
         )}

      
      <div
        className="modal fade provider-box-modal show"
        id="ProviderModal_single"
        tabIndex="-1"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        style={{ display: 'block' }}
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-scrollable">
          <div className="modal-content">
            <div ref={modalBodyRef} className="modal-body">
              {/* Header */}
              <div className="Home_header">
                <a
                  href="#"
                  className="HomeSection_header"
                  onClick={onClose}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                    cursor: 'pointer'
                  }}
                >
                  <div className="HomeSection_icon">
                    <div className="arrow left"></div>
                  </div>
                  <div className="HomeSection_label">{t('All Promotions')}</div>
                  <div className="HomeSection_right"></div>
                </a>
              </div>

              
              <div className="body main-layout-item promotion_box ColumnSection_list">
  <div className="Home_root">
    <div className="Home_games">
      <div className="HomeSectionCasinoGames_list">
        {promos.map((promo, idx) => (
          <div
            key={promo.content_id || idx}
            className="HomeSectionCasinoGames_game"
            onClick={() => openDetail(promo.content_id)}
          >
            <div className="CasinoGameCard_root">
              <div className="CasinoGamePreview_root">
                <div className="CasinoGamePreview_gradient"></div>
                <img
                  className="ResponsivePicture_img CasinoGamePreview_image"
                  src={promo.img}
                  alt={promo.title}
                  loading="lazy"
                />
              </div>
              <div className="title-boxPromotions">
                <a href="#">{promo.title}</a>
              </div>
            </div>
          </div>
        ))}

                      {loading && (
                        <div className="content-loader-games">
                          {t('Loading promotions')}...
                          <div className="loader-games"></div>
                        </div>
                      )}
                      {!loading && promos.length === 0 && (
                        <p>{t('No promotions found')}</p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ModalAllPromotions;
